$eve_app $eve_page
	plugins /
		<= Theme $mol_theme_auto
	title \$eve
	head /
		<= Title
		<= Switch
		<= Tools
	tools /
		<= Sources $mol_link_source
			uri \https://github.com/b-on-g/eve
			style *
				alignItems \center
		<= Lights $mol_lights_toggle
	body /
		<= Content
	Deck $mol_deck
		Switch => Switch
		Content => Content
		items /
			<= Libraries $eve_app_page_libraries
			<= Components_page $eve_app_page_components
			<= Design_page $eve_app_page_design
			<= Themer_page $eve_app_page_themer
